import { faPage4, faWindows } from "@fortawesome/free-brands-svg-icons";
import {
  faTachometer,
  faPlus,
  faNotdef,
  faUserGroup,
  faPeopleGroup
} from "@fortawesome/free-solid-svg-icons";

const initMenu = [
  {
    label: "Dashboard",
    path: "/",
    icon: faTachometer,
  },
  {
    label: 'Activity'
  },
  {
    label: "Groups",
    path: "/groups",
    icon: faUserGroup,
  },
  {
    label: "Add Group",
    path: "/groupform",
    icon: faNotdef,
  },
  
  {
    label: 'Friend'
  },
  {
    label: "Invite Friend",
    path: "/form",
    icon: faPlus,
  },
  {
    label: "Friends",
    path: "/friends",
    icon: faPeopleGroup,
  },

];

export default initMenu